// extracted by mini-css-extract-plugin
module.exports = {"description":"productCard_description__gyKIo","price":"productCard_price__uhX53","editButton":"productCard_editButton__yd3zH"};